import React from "react";

import { withRouter } from "react-router-dom";

import { isMobile } from "../../../../common-assets/js/rootui-parts/_utility";
import { OrderResultsContextProvider } from "./context/order-results-context";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

class OrdersResultsPage extends React.Component<any, any> {
    componentDidMount = updateBreadcrumb;

    render() {
        const { history, location } = this.props;

        if (isMobile) history.push(`/m${location.pathname}`);

        return (
            <PageWrap>
                <PageContent>
                    <OrderResultsContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </OrderResultsContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default withRouter(OrdersResultsPage);
